import React from "react";

type IconProps = { className?: string };

/** Figma "24 / Icon-close big" — the card's close button. */
export const CloseBigIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M4.16667 15.8333L10 10M10 10L15.8333 4.16667M10 10L4.16667 4.16667M10 10L15.8333 15.8333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
